module.exports = __webpack_public_path__ + "images/card-templates/header-card-template.05d178e750601eba6f93.png";